import { call, delay, select } from 'redux-saga/effects';
import { dispatch } from '@restore/helpers';
import {
  selectTabCoordinationState,
  selectFormManagementState,
  selectScoringFormCode,
} from '@restore/readerViewerSession/utils';
import { formManagementSlice } from '@restore/readerViewerSession/formManagement/formManagement.slice';
import { scoringFormSeriesChangedAction } from 'src/pages/Readings/ReadingTaskPage/utils';

export function* handleScoringFormRenderWorker() {
  yield dispatch(formManagementSlice.actions.setFormRendered(true));

  const { mainTab } = yield* selectTabCoordinationState();

  // Immediately initialize series in attached (main) tab by re-emitting the last known snapshot to the form.
  if (mainTab) {
    const { lastSeries } = yield* selectFormManagementState();
    if (Array.isArray(lastSeries) && lastSeries.length) {
      const scoringFormCode = yield* selectScoringFormCode();
      yield call(scoringFormSeriesChangedAction, scoringFormCode, lastSeries);
    }
    // One-shot reset of dirty state on initial load or task/subtask switch
    const { resetDirtyOnNextRender, isDirty, readOnly } = yield select(
      state => state.formManagement
    );
    if (readOnly) {
      // If readOnly, ensure no dirty flag is set at all
      yield dispatch(formManagementSlice.actions.setFormDirty(false));
      yield dispatch(formManagementSlice.actions.setResetDirtyOnNextRender(false));
    } else if (resetDirtyOnNextRender && !isDirty) {
      // wait until all events on the form initialization are completed
      // to prevent the pop-up about unsaved changes from appearing after loading or switching tasks
      yield delay(2000);
      yield dispatch(formManagementSlice.actions.setFormDirty(false));
      yield dispatch(
        formManagementSlice.actions.setResetDirtyOnNextRender(false)
      );
    }
  }
}
